<template>
  <fragment>
    <t-dialog ref="dialog" dense light fullscreen>
      <template v-slot:text>
        <iframe frameborder="0" height="99%" width="100%" :src="$config.urls.pagamento_url"/>
      </template>
    </t-dialog>
  </fragment>
</template>

<script>
import { TDialog } from '@/components/base'

export default {
  name: 'dialog-pagamento',
  components: { TDialog },
  mounted () {
    this.$events.$on('OPEN_PAGAMENTO_DIALOG', () => {
      this.$refs.dialog.open()
      this.step = 'cadastro'
    })
  },
  beforeDestroy () {
    this.$events.$off('OPEN_PAGAMENTO_DIALOG')
  }
}
</script>

<style lang="scss" scoped>
</style>
